<template>
  <span class="menu-beta-badge">Beta</span>
</template>

<script>
export default {
  name: 'MenuBetaBadge',
}
</script>

<style scoped>
.menu-beta-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.3;
  color: #fff;
  background: #f59e0b;
  border-radius: 3px;
  vertical-align: middle;
}
</style>
